import type { TemplateResult } from "lit"
import { html } from "lit"
import type { Language } from "@ligonier/shared"
import { sanitizeHeaderHref } from "@ligonier/shared"

export function renderLanguages(languages: Array<Language>): TemplateResult {
  return html`
    <div class="languages">
      <div class="container container-sm languages-container">
        <span class="languages-label">Ligonier Sites in:</span>
        <ul class="languages-list">
          ${languages.map(
            (lang) => html`
              <li class="language-item">
                <a href="${sanitizeHeaderHref(lang.url)}" class="language-link">${lang.label}</a>
              </li>
            `
          )}
        </ul>
      </div>
    </div>
  `;
}
